import { getUserDetails } from "components/service/userService/userService";
import { mixpanelCustomEvent } from "mixpanel/eventTriggers";
import { MixpanelEventName } from "mixpanel/types";
import { useCallback } from "react";
import { Role } from "types";

export const useRoleUpdater = ({
  user,
  isSignedIn,
  mixpanelProps,
}: {
  user: any;
  isSignedIn: boolean;
  mixpanelProps: any;
}) => {
  const updateRoles = useCallback(
    async (role?: Role) => {
      if (!isSignedIn || !user || !role) return;

      let currentRoles: string[] = [];

      try {
        const response = await getUserDetails();
        currentRoles = response.roles || [];
      } catch (error) {
        console.error("Failed to fetch user details:", error);
        return;
      }

      const validRoles = Object.values(Role);
      const shouldUpdateRole =
        validRoles.includes(role) && !currentRoles.includes(role);

      if (!shouldUpdateRole) {
        mixpanelCustomEvent({
          mixpanelProps: { ...mixpanelProps },
          id: user?.id?.toString() || "",
          eventName: MixpanelEventName.noNeededToUpdateRolesForUser,
        });
        return;
      }

      try {
        await user.update({
          unsafeMetadata: {
            roles: [...new Set([...currentRoles, role])],
          },
        });

        mixpanelCustomEvent({
          mixpanelProps: { ...mixpanelProps },
          id: user?.id?.toString() || "",
          eventName: MixpanelEventName.rolesUpdatedForUser,
        });
      } catch (error) {
        console.error("Failed to update roles:", error);
      }
    },
    [user, isSignedIn, mixpanelProps]
  );

  return { updateRoles };
};
